import _ from 'underscore';
import pageContext from '@bingads-webui-static-legacy/page-context';

export function logBidView(adgroup, activity) {
  if (activity && _.isFunction(activity.trace)) {
    activity.trace(
      `View adgroup bid suggestion success for ${adgroup.Id} with suggested bid ${adgroup.suggestedBid} (from NKW: ${adgroup.isNKW}), Currency: ${pageContext.AccountCurrencyCode}`,
      'SuggestionInCreationWorkflow/ViewBid'
    );
  }
}

export function logBidAdoption(adgroup, activity) {
  if (activity && _.isFunction(activity.trace)) {
    activity.trace(
      `Apply adgroup bid suggestion success for ${adgroup.Id} with suggested bid ${adgroup.suggestedBid} (from NKW: ${adgroup.isNKW}) and saved bid ${adgroup.SearchBid}, viewedSuggestion: ${adgroup.viewedSuggestion}, Currency: ${pageContext.AccountCurrencyCode}`,
      'SuggestionInCreationWorkflow/ApplyBid'
    );
  }
}

export function logBudgetView(campaign, activity) {
  if (activity && _.isFunction(activity.trace)) {
    activity.trace(
      `View campaign budget suggestion success for ${campaign.Id} with suggested budget ${campaign.suggestedBudget} and init budget ${campaign.initBudget}, current budget ${campaign.budget}, Currency: ${pageContext.AccountCurrencyCode}`,
      'SuggestionInCreationWorkflow/ViewBudget'
    );
  }
}

export function logBudgetAdoption(campaign, activity) {
  if (activity && _.isFunction(activity.trace)) {
    activity.trace(
      `Apply campaign budget suggestion success for ${campaign.Id} with suggested budget ${campaign.suggestedBudget} and init budget ${campaign.initBudget}, saved budget ${campaign.budget}, Currency: ${pageContext.AccountCurrencyCode}`,
      'SuggestionInCreationWorkflow/ApplyBudget'
    );
  }
}

export function logBudgetLandScapeView(campaignId, clientName, optId, suggestedBudgetValue, currency, activity) {
  if (activity && _.isFunction(activity.trace)) {
    activity.trace(
      `View inline budget suggestion success for CampaignId:${campaignId}, ClientName:${clientName}, BudgetSuggestionId:${optId}, SuggestedBudget:${suggestedBudgetValue}, Currency:${currency}`,
      'InlineBudgetEditor/ViewBudget'
    );
  }
}

export function logBudgetLandScapeAdoption(campaignId, clientName, optId, suggestedBudgetValue, userInputBudgetValue, currency, activity) {
  if (activity && _.isFunction(activity.trace)) {
    activity.trace(
      `Apply inline budget suggestion success for CampaignId:${campaignId}, ClientName:${clientName}, BudgetSuggestionId:${optId}, SuggestedBudget:${suggestedBudgetValue}, SavedBudget:${userInputBudgetValue}, Currency:${currency}`,
      'InlineBudgetEditor/ApplyBudget'
    );
  }
}

export function logBudgetLandScapeForSharedBudgetCampaignView(budgetId, clientName, optId, suggestedBudgetValue, currency, activity) {
  if (activity && _.isFunction(activity.trace)) {
    activity.trace(
      `View inline shared budget suggestion success for BudgetId:${budgetId}, ClientName:${clientName}, BudgetSuggestionId:${optId}, SuggestedBudget:${suggestedBudgetValue}, Currency:${currency}`,
      'InlineBudgetEditor/ViewBudget'
    );
  }
}

export function logBudgetLandScapeForSharedBudgetCampaignAdoption(budgetId, clientName, optId, suggestedBudgetValue, userInputBudgetValue, currency, activity) {
  if (activity && _.isFunction(activity.trace)) {
    activity.trace(
      `Apply inline shared budget suggestion success for BudgetId:${budgetId}, ClientName:${clientName}, BudgetSuggestionId:${optId}, SuggestedBudget:${suggestedBudgetValue}, SavedBudget:${userInputBudgetValue}, Currency:${currency}`,
      'InlineBudgetEditor/ApplyBudget'
    );
  }
}
